import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(protected readonly _router: Router, protected readonly _keycloak: KeycloakService) {
    super(_router, _keycloak);
  }

  public async isAccessAllowed() {
    if (!this.authenticated) {
      await this._keycloak.login({
        redirectUri: window.location.href,
      });
    }

    return true;
  }
}
